import React from "react";
import image from "../../../../../images/banners/prk.jpg";

export default function AntiCorrup() {
  return (
    <section className="anticorrup">
      {/* <section className=""> */}
      <a
        href="/about/anti-corruption"
        // target="_blank"
        rel="noopener noreferrer"
        className="anticorrup__link"
      >
        <img
          src={image}
          alt="Противодействие коррупции"
          className="anticorrup__img"
        />
      </a>
      {/* </section> */}
    </section>
  );
}
